import * as CSS from "csstype"
import { system } from "styled-system"

const gridColumnStart = system({
  gridColumnStart: true,
})

export interface GridColumnStartProps {
  gridColumnStart?:
    | CSS.Property.GridColumnStart
    | CSS.Property.GridColumnStart[]
}

export default gridColumnStart
